export const dummyTestimonials = [
  {
    title: 'Seamless Arrival',
    review: 'Very good location and nice apartment. They waited for us late at night for checking process and gave us all the instructions. Recommend it!',
    name: 'Bruno',
    location: 'Turin, Italy',
  },
  {
    title: 'Refined Excellence',
    review: 'Highly recommended host and property, very clean and spotless and even the furniture was very elegant and in excellent condition.',
    name: 'Hania',
    location: 'Dubai, United Arab Emirates',
  },
  {
    title: 'Premier Service',
    review: 'Great stay in Dubai. The host was friendly, responsive, and made everything smooth from check-in to check-out.',
    name: 'Pavel',
    location: 'Glasgow, United Kingdom',
  },
  {
    title: 'Dynamic Hosting',
    review: 'Nice place, nice area and Royal Vista always responded very quickly!',
    name: 'Laurence',
    location: 'Montreal, Canada',
  },
  {
    title: 'Professionalism',
    review: 'What great service. They were very patient and answered every question that I had. I am very satisfied!',
    name: 'Lily Karlheinz',
    location: 'Frankfurt',
  },
  {
    title: 'Enduring Comfort',
    review: 'Lovely property with many features for a comfortable stay. We only stayed 2 nights but i would definitely stay longer if i could.',
    name: 'Holly',
    location: 'Waianae, HI',
  },
];
